import React from 'react';
import DOMPurify from 'dompurify';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
const ProtectedDisclosureQuestions = props => {
  const { questionList = [], isMobile } = props;
  return (
    <div>
      {questionList.map((item, index) => {
        return (
          <div
            className='protected-accordian'
            id={isMobile && questionList[0].question === item.question ? 'removeLine' : ''}
          >
            <div data-testId='acordian-handle' className='global-accordian-container'>
              <div className='global-accordian-header-container'>
                <span className='global-accordian-header'>{item.question}</span>
              </div>
            </div>
            <div className='protected-accordian-answer' />
            <div
              className='global-accordian-content'
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(documentToHtmlString(item?.answer)),
              }}
            ></div>
          </div>
        );
      })}
    </div>
  );
};

export default ProtectedDisclosureQuestions;
